import MoviesApi from '../api/MoviesApi';
import MoviesConstants from '../constants/MoviesConstants';

export function getMovieByTitle(title) {
  return {
    types: [
      MoviesConstants.GET_MOVIE_BY_TITLE_REQUEST,
      MoviesConstants.GET_MOVIE_BY_TITLE_SUCCESS,
      MoviesConstants.GET_MOVIE_BY_TITLE_FAILURE
    ],
    apiRequest: () => MoviesApi.getMovieByTitle(title)
  };
}

export default {
  getMovieByTitle
};
